import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-tags-wrapper" }

import { ref, Ref, onMounted } from 'vue';
import CardTagsEditPopup from './CardTagsEditPopup.vue';
import CardTagsViewPopup from './CardTagsViewPopup.vue';


// `defineProps()` in `<script setup>` is hoisted, so use a separate `<script>` for module scope initializations
enum Mode {
  View = 'view',
  Edit = 'edit',
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CardTagsPopupWrapper',
  props: {
  cardId: {
    type: String,
    required: true,
  },
},
  emits: ['close-tippy', 'esc', 'tagSelected', 'singleTagSelected'],
  setup(__props, { expose: __expose, emit: __emit }) {

const viewRef: any = ref(null);
const editRef: any = ref(null);
const mode: Ref<Mode> = ref(Mode.View);



const setMode = (val: Mode) => {
  mode.value = val;
};

const focusInput = () => {
  if (mode.value === Mode.Edit) {
    editRef.value?.focusInput();
  } else {
    viewRef.value?.focusInput();
  }
};

const handleShow = () => {
  focusInput();
};

const handleEsc = () => {
  emit('esc');
};

const handleClose = () => {
  emit('close-tippy');
};

const handleTagSelected = (tag: any) => {
  emit('tagSelected', tag);
};

const handleSingleTagSelected = (tag: any) => {
  emit('singleTagSelected', tag);
};

const emit = __emit;

onMounted(() => {
  const focusTimeout = setTimeout(() => {
    focusInput();
    clearTimeout(focusTimeout);
  }, 0);
});

__expose({
  focusInput,
  handleShow,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (mode.value === Mode.View)
      ? (_openBlock(), _createBlock(CardTagsViewPopup, {
          key: 0,
          ref_key: "viewRef",
          ref: viewRef,
          "card-id": __props.cardId,
          onShowEditTagPopup: _cache[0] || (_cache[0] = ($event: any) => (setMode(Mode.Edit))),
          onClosePopup: handleClose,
          onEsc: handleEsc,
          onTagSelected: handleTagSelected,
          onSingleTagSelected: handleSingleTagSelected
        }, null, 8, ["card-id"]))
      : (mode.value === Mode.Edit)
        ? (_openBlock(), _createBlock(CardTagsEditPopup, {
            key: 1,
            ref_key: "editRef",
            ref: editRef,
            "card-id": __props.cardId,
            onShowViewTagPopup: _cache[1] || (_cache[1] = ($event: any) => (setMode(Mode.View))),
            onClosePopup: handleClose,
            onEsc: handleEsc
          }, null, 8, ["card-id"]))
        : _createCommentVNode("", true)
  ]))
}
}

})